﻿import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { ServiceFormValues } from "@/hooks/services/useServicesData";;
import type { UseFormReturn } from "react-hook-form";;

export function ServiceModal({
  modalOpen,
  setModalOpen,
  form,
  saveService,
  onSubmit,
}: {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  form: UseFormReturn<ServiceFormValues>;
  saveService: any;
  onSubmit: (data: ServiceFormValues) => void;
}) {
  return (
    <Dialog open={modalOpen} onOpenChange={setModalOpen}>
      <DialogContent className="sm:max-w-[425px] bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader>
          <DialogTitle className="text-xl">
            {form.getValues("id") ? "Editar Serviço" : "Novo Serviço"}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 mt-4">
          <div className="grid gap-2">
            <Label className="text-slate-300">Nome do Serviço *</Label>
            <Input
              placeholder="Ex: Lavagem Completa"
              {...form.register("name")}
              className="bg-slate-800 border-slate-700"
            />
            {form.formState.errors.name && (
              <span className="text-red-400 text-xs">
                {form.formState.errors.name.message}
              </span>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="grid gap-2">
              <Label className="text-slate-300">Valor (R$) *</Label>
              <Input
                type="number"
                step="0.01"
                {...form.register("price", { valueAsNumber: true })}
                className="bg-slate-800 border-slate-700"
              />
              {form.formState.errors.price && (
                <span className="text-red-400 text-xs">
                  {form.formState.errors.price.message}
                </span>
              )}
            </div>
            <div className="grid gap-2">
              <Label className="text-slate-300">Tempo (Minutos) *</Label>
              <Input
                type="number"
                {...form.register("time_minutes", { valueAsNumber: true })}
                className="bg-slate-800 border-slate-700"
              />
              {form.formState.errors.time_minutes && (
                <span className="text-red-400 text-xs">
                  {form.formState.errors.time_minutes.message}
                </span>
              )}
            </div>
          </div>

          <div className="grid gap-2">
            <Label className="text-slate-300">Descrição (Opcional)</Label>
            <Textarea
              placeholder="Ex: Inclui aspiração, cera líquida e pretinho."
              {...form.register("description")}
              className="bg-slate-800 border-slate-700 resize-none h-20"
            />
          </div>

          <div className="pt-4 flex justify-end gap-2">
            <Button
              type="button"
              variant="ghost"
              onClick={() => setModalOpen(false)}
              className="hover:bg-slate-800"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={saveService.isPending}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {saveService.isPending ? "Salvando..." : "Salvar"}
            </Button>
          </div>
          {Object.keys(form.formState.errors).length > 0 && (
            <div className="text-red-400 text-xs text-center mt-2">
              Verifique os campos obrigatórios.
            </div>
          )}
        </form>
      </DialogContent>
    </Dialog>
  );
}
